/** @jsxImportSource theme-ui */

import React from 'react';
import { motion, MotionConfig } from 'framer-motion';
import { CarrotTheme, Container } from '../index';
import { ThemeUIStyleObject } from 'theme-ui';

const DOT_DIAMETER = 11;
const SPACE_BETWEEN_DOTS = 4;
const TOTAL_SPACE_AROUND_DOT = SPACE_BETWEEN_DOTS * 2;

/* Work around for making sure we only take 3 Dots worth of space */
const POSITIONING_FIX = 1;

export const slidingDotsLoaderDot: ThemeUIStyleObject = {
    width: DOT_DIAMETER,
    height: DOT_DIAMETER,
    alignSelf: 'center',
    borderRadius: '50%',
    backgroundColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
    marginLeft: SPACE_BETWEEN_DOTS,
    marginRight: SPACE_BETWEEN_DOTS,
};

export const slidingDotsLoaderContainer: ThemeUIStyleObject = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
};

const dotAnimationVariants = {
    hideToStart: { scale: 0 },
    startInPreviousDotPosition: { x: -(TOTAL_SPACE_AROUND_DOT + DOT_DIAMETER) },
    grow: { scale: 1 },
    shrink: { scale: 0, x: -TOTAL_SPACE_AROUND_DOT },
    endInPosition: { x: 0 },
};

export function SlidingDotsLoader(): JSX.Element {
    return (
        <motion.div sx={{ ...slidingDotsLoaderContainer }}>
            <MotionConfig transition={{ repeat: Infinity, duration: 0.6 }}>
                <motion.span
                    style={{ paddingLeft: POSITIONING_FIX }}
                    variants={dotAnimationVariants}
                    initial={'hideToStart'}
                    animate={'grow'}
                >
                    <Container sx={{ ...slidingDotsLoaderDot }} />
                </motion.span>
                <motion.span
                    variants={dotAnimationVariants}
                    initial={'startInPreviousDotPosition'}
                    animate={'endInPosition'}
                >
                    <Container sx={{ ...slidingDotsLoaderDot }} />
                </motion.span>
                <motion.span
                    variants={dotAnimationVariants}
                    initial={'startInPreviousDotPosition'}
                    animate={'endInPosition'}
                >
                    <Container sx={{ ...slidingDotsLoaderDot }} />
                </motion.span>
                <motion.span
                    style={{ width: POSITIONING_FIX }}
                    variants={dotAnimationVariants}
                    initial={'startInPreviousDotPosition'}
                    animate={'shrink'}
                >
                    <Container sx={{ ...slidingDotsLoaderDot }} />
                </motion.span>
            </MotionConfig>
        </motion.div>
    );
}
